/* eslint-disable eqeqeq */
import React from 'react';
import { connect } from "react-redux";
import DataGridBase from '../../../../partials/layout/DataGridBase';
import PortletSpinner from '../../../../partials/layout/PortletSpinner';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import { systemAccountStatus, countries, GetCurrencyCodes, autoCreateRelationshipMode } from "../../../../shared/lookup";
import { Badge } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import CustomFieldHelper from "../../../contract/_Helpers/CustomFieldHelper";
import { withRouter } from '../../../../shared/hoc/withRouter';
import  { GetAccessRights } from "../../../../router/Protector/Protector";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as companiesCrud from '../../../../crud/companies.crud';
import * as companyUserCrud from '../../../../crud/companyUser.crud';
import * as companyDuck from '../../../../store/ducks/company.duck';
import Common from "../../../../shared/common";
import { listAccountsAllowedRegisterBatchOperations } from '../../../../router/Protector/AccessExceptions';

const isFinancialLimitEnabled = process.env.REACT_APP_FINANCIAL_LIMIT_ENABLED === "true";
const isPowerBIMenusEnabled = process.env.REACT_APP_POWERBI_ENABLED === "true";
const overrideAuth0Enabled = process.env.REACT_APP_OVERRIDE_AUTH0_ENABLED === "true" && !!process.env.REACT_APP_SSO_METHOD;
const isAIAllowed = process.env.REACT_APP_AI_ENABLED === "true";
const isAutoCreateRelationshipModeEnabled = process.env.REACT_APP_AUTO_CREATE_RELATIONSHIP_MODE_ENABLED === "true";

class CompanyUsers extends React.Component {
  constructor(props) {
    super(props);
    this.canCreateNew  = GetAccessRights("/admin/companies/:id/new-company-user", this.props.userProfile).allowAccess;
    this.columns = [
      { resource: "COMPANY.USER.FIELD.ID", dataField: "accountid", dataType: 'string' },
      { resource: "COMPANY.USER.FIELD.USERNAME", dataField: "username" },
      { resource: "COMPANY.USER.FIELD.NAME", dataField: "name" },
      { resource: "COMPANY.USER.FIELD.TYPE", dataField: "type" },
      { resource: "COMPANY.USER.FIELD.EMAIL", dataField: "email" },
      { resource: "COMPANY.USER.FIELD.JOB_TITLE", dataField: "jobtitle" },
      { resource: "COMPANY.USER.FIELD.TELEPHONE", dataField: "telephone" },
      { resource: "COMPANY.USER.FIELD.LASTLOGINDATE", dataField: "lastlogindate", dataType: 'date' },
      { resource: "COMPANY.USER.FIELD.STATUS", dataField: "deleted", cellRender: this.renderStatusColumn, lookup: { dataSource: systemAccountStatus, displayExpr: 'value', valueExpr: 'key' } }
    ];
    if (isFinancialLimitEnabled) {
      this.columns.push(
        { resource: "GENERAL.FORMS.FIELD.FINANCIAL_LIMIT_AMOUNT", dataField: "userlimit" },
        { resource: "GENERAL.FORMS.FIELD.FINANCIAL_LIMIT_CURRENCY", dataField: "userlimitcurrency" },
      )
    }
    this.columns.push(
      { resource: "CONTRACT.USERS.FIELD.EMAILS_DISABLED", dataField: "disableglobalemailnotifications" },
      { resource: "COMPANY.USER.FIELD.EMAILS_OPTEDOUT", dataField: "optoutemailnotifications" },
    )

    if (isAIAllowed) {
      this.columns.push(
        { resource: "COMPANY.USER.FIELD.HAS_AI_ACCESS", dataField: "allowai" }
      )
    }

    if (isAutoCreateRelationshipModeEnabled) {
      this.columns.push(
        { resource: "COMPANY.USER.FIELD.AUTO_CREATE_RELATIONSHIP", dataField: "autocreaterelationshipmode" }
      )
    }

    this.columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(props.company.usercustomfields));

    this.currencyCodes = GetCurrencyCodes(props.intl);
    this.roles = Common.getFilteredRoles(props.userProfile);

    this.batchOperationsEnabled = false;
    if (process.env.REACT_APP_BATCH_OPERATIONS_ENABLED === "true") {
        //REGISTER SUPPORTS BATCH OPERATION
        if (listAccountsAllowedRegisterBatchOperations.includes(this.props.userProfile.accounttype)) {
            this.batchOperationsEnabled = true;
        }
    }

    this.state = {
      company: null,
      companies: [],
      formFields: null
    }
  }
  getFormConfig = (userTypeOptions) => {
      const formFields = [
          {
              caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.USERNAME' }),
              dataField: 'Username',
              required: true,
              dataType: 'string',
              pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
          }
      ];

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.EMAIL' }),
          dataField: 'Email',
          required: true,
          dataType: 'string',
          pattern: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.NAME' }),
          dataField: 'Fullname',
          required: true,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.JOB_TITLE' }),
          dataField: 'jobtitle',
          required: false,
          dataType: 'string'
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.TELEPHONE' }),
          dataField: 'Telephone',
          required: false,
          dataType: 'integer',
          pattern: /^[0-9+]*$/
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.COUNTRY' }),
          dataField: 'Country',
          required: true,
          dataType: 'list',
          options: {
              dataSource: countries
          }
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.TYPE' }),
          dataField: 'Usertype',
          required: true,
          dataType: 'list',
          options: {
              dataSource: userTypeOptions
          }
      });

      if (process.env.REACT_APP_SSO_METHOD === 'DISCOVER' && this.props.company.companytenants?.length > 0) {
        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.SSO_TENANT' }),
            dataField: 'companytenantid',
            required: false,
            dataType: 'list',
            options: {
                dataSource: this.props.company.companytenants,
                valueExpr: 'companytenantid',
                displayExpr: 'description'
            }
        });
      }

      if (isFinancialLimitEnabled) {
        const options = [{ value: 1, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}, { value: 0, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.APPLYFINANCIALLIMIT' }),
            dataField: 'applyfinanciallimit',
            required: true,
            dataType: 'list',
            options: {
                dataSource: options,
                valueExpr: 'value',
                displayExpr: 'display'
            }
        });
      }

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.LIMIT' }),
          dataField: 'userlimit',
          required: false,
          dataType: 'decimal',
          dependOn: {
            field: 'applyfinanciallimit',
            expectedValues: [1, true, '1', 'true', 'Yes'],
          }
      });

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'CONTRACT.FIELD.CURRENCY' }),
          dataField: 'userlimitcurrency',
          required: false,
          dataType: 'list',
          dependOn: {
            field: 'applyfinanciallimit',
            expectedValues: [1, true, '1', 'true', 'Yes'],
          },
          options: {
              dataSource: this.currencyCodes,
              valueExpr: 'code',
              displayExpr: 'name'
          }
      });

      if (isPowerBIMenusEnabled) {
        const options = [{ value: 1, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}, { value: 0, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.ALLOW_POWERBI_MENUS' }),
            dataField: 'allowpowerbimenus',
            required: true,
            dataType: 'list',
            options: {
              dataSource: options,
              valueExpr: 'value',
              displayExpr: 'display'
            }
        });
      };

      if (overrideAuth0Enabled) {
        const options = [{ value: 1, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}, { value: 0, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.ALLOW_NON_SSO' }),
            dataField: 'OverrideSSOAuthentication',
            required: true,
            dataType: 'list',
            options: {
              dataSource: options,
              valueExpr: 'value',
              displayExpr: 'display'
            }
        });
      };

      if (isAIAllowed) {
        const options = [{ value: 1, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_YES" })}, { value: 0, display: this.props.intl.formatMessage({ id: "GENERAL.FORMS.SWITCH_NO" })}];

        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.ALLOW_AI' }),
            dataField: 'allowai',
            required: true,
            dataType: 'list',
            options: {
              dataSource: options,
              valueExpr: 'value',
              displayExpr: 'display'
            }
        });
      };

      if (isAutoCreateRelationshipModeEnabled) {
        formFields.push({
            caption: this.props.intl.formatMessage({ id: 'COMPANY.USER.FIELD.AUTO_CREATE_RELATIONSHIP' }),
            dataField: 'autocreaterelationshipmode',
            required: true,
            dataType: 'list',
            options: {
              dataSource: autoCreateRelationshipMode,
              // valueExpr: 'value',
              // displayExpr: 'display'
            }
        });
      };

      formFields.push({
          caption: this.props.intl.formatMessage({ id: 'COMPANY.FIELD.COMPANY_ID' }),
          dataField: 'companyid',
          required: false,
          dataType: 'integer',
          visibleInTemplate: false,
          defaultValue: this.props.company.companyid
      });

      return formFields;
  }
  getUserTypesOptions = () => {
    companyUserCrud.getUserTypeToSelectList()
      .then(response => {
        const types = response.data;
        const formFields = this.getFormConfig(types);
        this.setState({ formFields });
      })
      .catch(err => {
        this.props.enqueueSnackbar(err.toString(), { variant: 'error' });
      });
  }
  componentDidMount() {
    if (!this.props.company.enablecompanyusers) {
      this.fetchCompanies();
    }

    this.getUserTypesOptions();
  }
  fetchCompanies = async () => {
    let companies = [];
    
    try {
      companies = (await companiesCrud.getCompanies()).data;
      const filteredCompanies = JSON.parse(companies.aggregatelist).filter(c => c.archived !== 1 && c.enablecompanyusers != 0 && c.companyid != this.props.params.companyid);
      this.setState({ companies: filteredCompanies });
    } catch (err) {
      this.props.enqueueSnackbar("Error fetching companies: " + err.toString(), { variant: 'error', });
    }
  }
  onTableSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData.length > 0) {
      const data = selectedRowsData[0];
      this.props.navigate(this.props.location.pathname + '/' + data.accountid, { replace: false });
    }
  }
  renderStatusColumn = (cellInfo) => {
    let badgeVariant = 'secondary';
    let label = '';
    switch (cellInfo.data.deleted) {
      case 1:
        label = this.props.intl.formatMessage({ id: "GENERAL.ACCOUNT.STATUS_PASSIVE" })
        badgeVariant = 'secondary';
        break;
      case 0:
        label = this.props.intl.formatMessage({ id: "GENERAL.ACCOUNT.STATUS_ACTIVE" })
        badgeVariant = 'success';
        break;
      default:
        break;
    }
    return (<Badge variant={badgeVariant}>{label}</Badge>);
  }
  render() {
    if (!this.props.companyUsers || !this.props.company || (!this.props.company.enablecompanyusers && !this.state.companies) || !this.state.formFields) {
      return (<PortletSpinner />);
    }

    const addUsersToCompanyName = !this.props.company.enablecompanyusers ? this.state.companies.find(c => c.companyid === this.props.company.adduserstocompanyid)?.name : null

    return (
      <Portlet>
        <PortletBody>
          {
            !this.props.company.enablecompanyusers ? (
              <Alert variant="warning" style={{ display: 'block', margin: 20 }}>
                  <Alert.Heading><FormattedMessage id="COMPANY.USERS.ALERT.IS_NOT_ALLOWED_TO_ADD_USERS" /></Alert.Heading>
                  <hr />
                  <p>
                  {addUsersToCompanyName && (
                    <>
                      <FormattedMessage
                        id="COMPANY.USERS.WARNING.LINK_TO_COMPANY"
                        values={{ LINK: (<Link to={`/admin/companies/${this.props.company.adduserstocompanyid}/users`} style={{ fontWeight: 500 }}>{addUsersToCompanyName}</Link>) }}
                      />
                      <br />
                    </>
                  )}
                      <FormattedMessage id="COMPANY.USERS.WARNING.LINK_TO_SETTING" values={{ LINK: (<Link to={`/admin/companies/${this.props.company.companyid}/overview`} style={{ fontWeight: 500 }}><FormattedMessage id="COMPANY.USERS.WARNING.COMPANY_OVERVIEW_PAGE"/></Link>) }} /><br />
                  </p>
              </Alert>
            ) : (
              <DataGridBase
                version="2"
                //BATCH OPS
                batchOperations={this.batchOperationsEnabled}
                batchFormFields={this.state.formFields}
                batchImportEndpoint={companyUserCrud.importCompanyUsers}
                onBatchRecordsUpdated={this.props.reloadCompanyUsers}
                customFields={this.props.customFields}
                //BATCH OPS
                title={this.props.intl.formatMessage({ id: "COMPANY.USERS.TITLE" })}
                createPath={!this.props.company.deactivated && this.canCreateNew ? `/admin/companies/${this.props.company.companyid}/new-company-user` : null}
                name={this.props.intl.formatMessage({ id: "COMPANY.USERS.TITLE" })}
                dataSource={this.props.companyUsers}
                onSelectionChanged={this.onTableSelectionChanged}
                keyExpr="companyuserid"
                columns={this.columns}
              />
            )
          }
        </PortletBody>
      </Portlet>
    );
  }
}

const mapStateToProps = store => ({
  company: store.company.company,
  companyUsers: store.company.companyUsers,
  userProfile: store.auth.userProfile
});

const mapDispatchToProps = {
    reloadCompanyUsers: companyDuck.actions.reloadUsers
}

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(CompanyUsers)));
